/**
 *
 */
import None from './none.svg';
import square from './square.svg';
import circle from './circle.svg';
import rSquare from './r-square.svg';
import cSquare from './c-square.svg';

/**
 * EyeInnerJs
 * @type {({icon: *})[]}
 */
export const EyeInner = [
  { name: 'none', icon: None },
  { name: 'square', icon: square },
  { name: 'circle', icon: circle },
  { name: 'r-square', icon: rSquare },
  { name: 'c-square', icon: cSquare }
]

export default EyeInner;